import React from 'react';
import Menu from './Components/menu';
import Banner from './Components/banner';
import Features from './Components/features';
import Parceria from './Components/parceria';
import Precos from './Components/precos';
import Footer from '../comum/Footer';

function Site(){
    return <div>
      <Menu/>
      {/*<Banner/>*/}
      <Features/>
      {/*<Parceria/>*/}
      <Precos/>
      <Footer/>
    </div>;
  }

export default Site;